export default function R_StatisticsIntro() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_StatisticsIntro Component</h1>
      <p>This is the R_StatisticsIntro tutorial section.</p>
    </div>
  );
}
